import styles from '../styles/scrollable.scss';

export default function scrollParent() {
  return typeof window !== 'undefined'
    ? window.document.getElementsByClassName(styles.scrollable)[0] || window.document.body
    : null;
}
